export default {
      id: "checkmark-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#checkmark",
      toString: function () {
        return this.url;
      }
    }